import type React from 'react';

import { DeleteRounded } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';

import { Dropzone } from './dropzone';

import type { Accept } from 'react-dropzone';

interface FilePickerFieldProps {
  accept: Accept;
  file: File | undefined;
  hasError: boolean;
  onFileSelected: (file: File | undefined) => void;
  onFileRejected: (rejected: boolean) => void;
  onClear: () => void;
}

export const FilePickerField = ({
  accept,
  file,
  hasError,
  onFileSelected,
  onFileRejected,
  onClear,
}: FilePickerFieldProps): React.ReactElement => {
  if (file != null) {
    return (
      <TextField
        variant='outlined'
        defaultValue={file.name}
        fullWidth
        disabled
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton onClick={onClear}>
                  <DeleteRounded />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    );
  }

  return (
    <Dropzone accept={accept} hasError={hasError} onFileSelected={onFileSelected} onFileRejected={onFileRejected} />
  );
};
